import * as React from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppStoreProvider } from './store/AppStore';
import CustomRouterProvider from './route/app-routes';
import { GlobalComponents } from './components/plataforma/global-components';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/es';
import { acercateTheme } from './themes/acercateTheme';

function App() {
  return (
    <ThemeProvider theme={acercateTheme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <AppStoreProvider>
          <GlobalComponents>
            <CustomRouterProvider />
          </GlobalComponents>
        </AppStoreProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
